<template>
    <div>
        <h2>Who is Family?</h2>
        <p class="intro">You will go through a journey of five Themes with five questions per theme. Take your time, you will see how insightful this is!</p>
        
        <div id="who-is-family">
            <div id="question1" v-if="currentQuestion == 1">
                <h3 class="first">Theme I: Learning</h3>
                <p><span class="letter">Question 1.</span> <span class="left">I tend to learn by myself or with external peers and resources, but I can't say I learn a lot in life with my parents, siblings, cousins or our next gen.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I learn a lot in life with my parents, siblings, cousins or our next gen through planned or spontaneous discussions, activities and exchanges.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer1">
                    <li class="first" @click="setAnswer(1, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(1, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(1, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(1, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(1, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(1, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(1, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question2" v-if="currentQuestion == 2">
                <h3>Theme I: Learning</h3>
                <p><span class="letter">Question 2.</span> <span class="left">In my family, we know a little bit about our past, a few bites and anecdotes here and there.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">In my family, we share a lot of stories about our ancestors, where we came from, our values and what we experienced.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer2">
                    <li class="first" @click="setAnswer(2, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(2, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(2, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(2, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(2, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(2, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(2, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question3" v-if="currentQuestion == 3">
                <h3>Theme I: Learning</h3>
                <p><span class="letter">Question 3.</span> <span class="left">I can draw by heart on a piece of paper one or two generations of my close family with most names.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I can draw from memory on a piece of paper several generations and branches of my family with all the names.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer3">
                    <li class="first" @click="setAnswer(3, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(3, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(3, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(3, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(3, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(3, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(3, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question4" v-if="currentQuestion == 4">
                <h3>Theme I: Learning</h3>
                <p><span class="letter">Question 4.</span> <span class="left">I cannot recall a word or expression that defines who we are as a family.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">In my family, we have a living motto or <em>"mot d'ordre"</em> that has a meaning for each of us and that defines us as a group.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer4">
                    <li class="first" @click="setAnswer(4, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(4, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(4, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(4, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(4, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(4, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(4, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question5" v-if="currentQuestion == 5">
                <h3>Theme I: Learning</h3>
                <p><span class="letter">Question 5.</span> <span class="left">I seldom find or have opportunities to educate myself together with my parents, siblings, cousins or our next gen.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">It is part of my life to go to seminars or training programs with my parents, siblings, cousins or our next gen or to organize some educational activities with them whereby we educate ourselves together, which might include inviting guest speakers, listening to experts and debriefing as a group.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer5">
                    <li class="first" @click="setAnswer(5, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(5, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(5, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(5, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(5, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(5, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(5, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question6" v-if="currentQuestion == 6">
                <h3 class="first">Theme II: Boundaries</h3>
                <p><span class="letter">Question 1.</span> <span class="left">In a typical week, I regularly see, speak or share thoughts with the same few family members.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">In a typical week, I tend to have meaningful exchanges with many members among my parents, siblings, cousins, spouses or our next gen.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer6">
                    <li class="first" @click="setAnswer(6, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(6, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(6, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(6, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(6, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(6, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(6, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question7" v-if="currentQuestion == 7">
                <h3>Theme II: Boundaries</h3>
                <p><span class="letter">Question 2.</span> <span class="left">Close family friends are not family to me, they belong to a different class of relationships.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I make no distinction between close family friends and family, to me it's all part of the same big family.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer7">
                    <li class="first" @click="setAnswer(7, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(7, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(7, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(7, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(7, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(7, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(7, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question8" v-if="currentQuestion == 8">
                <h3>Theme II: Boundaries</h3>
                <p><span class="letter">Question 3.</span> <span class="left">If we owned something together as a family, I would never involve in-laws, spouses, step children or adopted children in that ownership; it belongs to the blood line.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">If we owned something together as a family, I would consider that we can share or divide ownership with members of the extended family including in-laws, spouses, step children or adopted children.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer8">
                    <li class="first" @click="setAnswer(8, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(8, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(8, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(8, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(8, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(8, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(8, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question9" v-if="currentQuestion == 9">
                <h3>Theme II: Boundaries</h3>
                <p><span class="letter">Question 4.</span> <span class="left">When we have family dinners or gatherings, I am not comfortable having in-laws or significant others share their points of view about family decisions or orientations.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">What I enjoy about family dinners and gatherings is that everyone including in-laws and significant others can influence or orient family conversations and some decisions.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer9">
                    <li class="first" @click="setAnswer(9, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(9, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(9, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(9, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(9, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(9, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(9, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question10" v-if="currentQuestion == 10">
                <h3>Theme II: Boundaries</h3>
                <p><span class="letter">Question 5.</span> <span class="left">I make a clear distinction between my direct cousins and second cousins.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">To me, all my cousins are the same, no matter the generation and branch.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer10">
                    <li class="first" @click="setAnswer(10, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(10, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(10, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(10, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(10, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(10, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(10, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question11" v-if="currentQuestion == 11">
                <h3 class="first">Theme III: Trust</h3>
                <p><span class="letter">Question 1.</span> <span class="left">I trust very few members of my family, I share confidential information with only a few.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I give my trust to a relatively large number of individuals in my family across generations or branches.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer11">
                    <li class="first" @click="setAnswer(11, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(11, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(11, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(11, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(11, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(11, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(11, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question12" v-if="currentQuestion == 12">
                <h3>Theme III: Trust</h3>
                <p><span class="letter">Question 2.</span> <span class="left">I share my dreams with people from the outside, not with family. I am afraid they would judge me or not understand or appreciate what I think.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I like to share my dreams with my family as it makes them somehow more clear, real and achievable.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer12">
                    <li class="first" @click="setAnswer(12, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(12, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(12, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(12, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(12, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(12, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(12, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question13" v-if="currentQuestion == 13">
                <h3>Theme III: Trust</h3>
                <p><span class="letter">Question 3.</span> <span class="left">Very few people in my family trust me.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I know from direct sources many family secrets, dreams, concerns or aspirations.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer13">
                    <li class="first" @click="setAnswer(13, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(13, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(13, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(13, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(13, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(13, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(13, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question14" v-if="currentQuestion == 14">
                <h3>Theme III: Trust</h3>
                <p><span class="letter">Question 4.</span> <span class="left">I avoid discussing emotional topics with family, it quickly becomes uncomfortable or out of control.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I might like or dislike discussing emotional topics with family based on my personality, but I don't feel it is a burden doing so because of the openness and non-judgmental approach we have with one another.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer14">
                    <li class="first" @click="setAnswer(14, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(14, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(14, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(14, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(14, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(14, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(14, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question15" v-if="currentQuestion == 15">
                <h3>Theme III: Trust</h3>
                <p><span class="letter">Question 5.</span> <span class="left">There is a sense of disappointment in our family when we think about who's reliable and who can help whom.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">There is a strong sense of reliability in my family. I always find that in the case of need, we can rely upon one another.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer15">
                    <li class="first" @click="setAnswer(15, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(15, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(15, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(15, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(15, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(15, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(15, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question16" v-if="currentQuestion == 16">
                <h3 class="first">Theme IV: Identity</h3>
                <p><span class="letter">Question 1.</span> <span class="left">I mainly share inside jokes and jargon with people from the outside, but do occasionally so with family.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">My family and I have a dictionary of inside jokes and jargon that makes it sometimes hard for outsiders to understand us.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer16">
                    <li class="first" @click="setAnswer(16, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(16, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(16, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(16, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(16, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(16, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(16, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question17" v-if="currentQuestion == 17">
                <h3>Theme IV: Identity</h3>
                <p><span class="letter">Question 2.</span> <span class="left">When I feel lost or under stress, I cope on my own or may reach out to outside people like colleagues, friends or professionals.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">When I feel lost or under stress, I can quite instinctively turn to some of our family values to find back my balance, or reach out to some family members who will bring back those values to me.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer17">
                    <li class="first" @click="setAnswer(17, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(17, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(17, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(17, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(17, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(17, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(17, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question18" v-if="currentQuestion == 18">
                <h3>Theme IV: Identity</h3>
                <p><span class="letter">Question 3.</span> <span class="left">I have a very short term view of family, I don't have a very clear picture of our identity and future in a decade or two.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">When I think of my family, there is a sense of past, present and future that all comes together in a meaningful image.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer18">
                    <li class="first" @click="setAnswer(18, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(18, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(18, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(18, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(18, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(18, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(18, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question19" v-if="currentQuestion == 19">
                <h3>Theme IV: Identity</h3>
                <p><span class="letter">Question 4.</span> <span class="left">“Limit projects with family”, is my saying.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I say: “Multiply projects with family and explore them through various angles to give them more meaning.”<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer19">
                    <li class="first" @click="setAnswer(19, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(19, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(19, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(19, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(19, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(19, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(19, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question20" v-if="currentQuestion == 20">
                <h3>Theme IV: Identity</h3>
                <p><span class="letter">Question 5.</span> <span class="left">We don't have a strong family identity because each of us tend to individually adhere to our in-laws, spouses or close family friends' identity.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">Our family identity is so strong that it attracts in-laws, spouses or close family friends like a magnet as they strongly identify themselves to our behavior, dreams and ways of life.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer20">
                    <li class="first" @click="setAnswer(20, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(20, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(20, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(20, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(20, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(20, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(20, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question21" v-if="currentQuestion == 21">
                <h3 class="first">Theme V: Conflicts and communication</h3>
                <p><span class="letter">Question 1.</span> <span class="left">In my family, we don't address conflicts, we keep everything buried and have triangular conversations about it.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">In my family, we have this habit of opening up conflicts and addressing them at the root.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer21">
                    <li class="first" @click="setAnswer(21, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(21, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(21, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(21, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(21, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(21, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(21, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question22" v-if="currentQuestion == 22">
                <h3>Theme V: Conflicts and communication</h3>
                <p><span class="letter">Question 2.</span> <span class="left">In my family, we avoid having conflicts.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">In my family, we experience some minor or serious conflicts.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer22">
                    <li class="first" @click="setAnswer(22, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(22, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(22, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(22, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(22, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(22, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(22, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question23" v-if="currentQuestion == 23">
                <h3>Theme V: Conflicts and communication</h3>
                <p><span class="letter">Question 3.</span> <span class="left">If we ever had a conflict in our family, I feel that we would primarily reach to the outside to find help in addressing or dealing with it.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">The history of our family is that we would seldom reach to the outside to address and deal with our conflicts, we would tend to discuss them and manage them by ourselves and only go to the outside if necessary.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer23">
                    <li class="first" @click="setAnswer(23, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(23, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(23, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(23, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(23, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(23, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(23, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question24" v-if="currentQuestion == 24">
                <h3>Theme V: Conflicts and communication</h3>
                <p><span class="letter">Question 4.</span> <span class="left">I wish that in my family, we would listen more to one another.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">We are quite good at listening to one another in my family, it's something I even take pride in.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer24">
                    <li class="first" @click="setAnswer(24, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(24, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(24, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(24, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(24, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(24, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(24, '3');"><a>3</a></li>
                </ul>
            </div>
            <div id="question25" v-if="currentQuestion == 25">
                <h3>Theme V: Conflicts and communication</h3>
                <p><span class="letter">Question 5.</span> <span class="left">There are only a few family members with whom I can have a real sense of communication, whether it's one-on-one or as a small group.<span class="arrow"></span><span class="arrow"></span></span> <span class="right">I find there are many opportunities and forums in my family to have some meaningful small groups and large groups discussions.<span class="arrow"></span><span class="arrow"></span></span></p>
                <ul :class="'slider answer' + answer25">
                    <li class="first" @click="setAnswer(25, '-3');"><a>-3</a></li>
                    <li class="second" @click="setAnswer(25, '-2');"><a>-2</a></li>
                    <li class="third" @click="setAnswer(25, '-1');"><a>-1</a></li>
                    <li class="fourth" @click="setAnswer(25, '0');"><a>0</a></li>
                    <li class="fifth" @click="setAnswer(25, '1');"><a>1</a></li>
                    <li class="sixth" @click="setAnswer(25, '2');"><a>2</a></li>
                    <li class="seventh" @click="setAnswer(25, '3');"><a>3</a></li>
                </ul>
            </div>
            
            <p class="instruction" v-if="!isSolving">Position yourself on this scale</p>
            
            <div id="next-theme" v-if="isNextTheme() && !isEnd">
                <p class="button"><a class="goto" @click="nextQuestion()">Next Theme</a></p>
            </div>
            <div id="next-question" v-if="nextIsVisible && !isNextTheme()">
                <p class="button"><a class="goto" @click="nextQuestion()">Next Question</a></p>
            </div>

            <div id="next" v-if="(isEnd && !isSolving)">
                <p><strong><em>You have now completed the assessment, click Next to review your results.</em></strong></p>
                <p class="button"><a class="goto" @click="displayResult()">Next</a></p>
            </div>

            <div id="result" v-if="isResult">
                <p class="button"><a class="goto" @click="displayResult()">Display results</a></p>
            </div>

            <!--div id="close" v-if="isResult">
                <p class="button"><a class="goto" @click="displayResult()">Display results</a></p>
            </div-->

            <div id="solving" v-if="isSolving">
                
                <div id="graphic-print" v-if="!showResult" @click="showAnswer()"><img :src="baseurl + 'assets/images/graphic-print.jpg'" alt="Graphic with score" id="graph-score"><img :src="baseurl + 'assets/images/graphic-hover-print.jpg'" alt="Graphic with description" id="graph-info"></div>
                <div id="graphic" v-if="showResult" @click="showDescription()">
                    <div class="icon1" :style="resultStyle1">
                        <span title="LF Theme I: Learning Family - About learning together"></span>
                    </div>
                    <div class="icon2" :style="resultStyle2">
                        <span title="FB Theme II: Family Boundaries - About who belongs to the family"></span>
                    </div>
                    <div class="icon3" :style="resultStyle3">
                        <span title="FT Theme III: Family Trust - About who we can trust"></span>
                    </div>
                    <div class="icon4" :style="resultStyle4">
                        <span title="FI Theme IV: Family Identity - About how we define our identity"></span>
                    </div>
                    <div class="icon5" :style="resultStyle5">
                        <span title="FCC Theme V: Family Conflicts and Communication - About who we communicate and address conflicts with"></span>
                    </div>
                </div>
                <div id="legend">
                    <ul>
                        <li class="icon1"><span>&nbsp;</span> <span class="acc">LF</span> Theme I: Learning Family - About learning together</li>
                        <li class="icon2"><span>&nbsp;</span> <span class="acc">FB</span> Theme II: Family Boundaries - About who belongs to the family</li>
                        <li class="icon3"><span>&nbsp;</span> <span class="acc">FT</span> Theme III: Family Trust - About who we can trust</li>
                        <li class="icon4"><span>&nbsp;</span> <span class="acc">FI</span> Theme IV: Family Identity - About how we define our identity</li>
                        <li class="icon5"><span>&nbsp;</span> <span class="acc">FCC</span> Theme V: Family Conflicts and Communication - About who we communicate and address conflicts with</li>
                    </ul>
                    <p class="remember">Remember that our sense of identity evolves through time. Take this test once in a while. Also compare and discuss your answers with members in your family.</p>
                </div>
                <p v-if="!showResult" class="howto1" @click="showAnswer()">Click on the triangle to see your results</p>
                <p v-if="showResult" class="howto2" @click="showDescription()">Click on the triangle to see the description of each zone</p>
                
                <!--div id="review">
                    <p class="button"><a class="goto" @click="showAll()">Review answers</a></p>
                </div-->
                <div id="redo">
                    <p class="button"><a class="goto" @click="reset()">Redo test</a></p>
                </div>
                
            </div>
        </div>
    </div>
</template>



<script>


function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}


export default {
    name: "who-is-family",
    components: {

    },
    data() {
        return {
            currentQuestion: 1,
            nextIsVisible: 0,
            isEnd: (getCookie("isEnd") ? getCookie("isEnd") : 0),
            isSolving: 0,
            showResult: 0,
            all: 0,

            answer1: (getCookie("answer1") ? parseInt(getCookie("answer1")) : ''),
            answer2: (getCookie("answer2") ? parseInt(getCookie("answer2")) : ''),
            answer3: (getCookie("answer3") ? parseInt(getCookie("answer3")) : ''),
            answer4: (getCookie("answer4") ? parseInt(getCookie("answer4")) : ''),
            answer5: (getCookie("answer5") ? parseInt(getCookie("answer5")) : ''),
            answer6: (getCookie("answer6") ? parseInt(getCookie("answer6")) : ''),
            answer7: (getCookie("answer7") ? parseInt(getCookie("answer7")) : ''),
            answer8: (getCookie("answer8") ? parseInt(getCookie("answer8")) : ''),
            answer9: (getCookie("answer9") ? parseInt(getCookie("answer9")) : ''),
            answer10: (getCookie("answer10") ? parseInt(getCookie("answer10")) : ''),
            answer11: (getCookie("answer11") ? parseInt(getCookie("answer11")) : ''),
            answer12: (getCookie("answer12") ? parseInt(getCookie("answer12")) : ''),
            answer13: (getCookie("answer13") ? parseInt(getCookie("answer13")) : ''),
            answer14: (getCookie("answer14") ? parseInt(getCookie("answer14")) : ''),
            answer15: (getCookie("answer15") ? parseInt(getCookie("answer15")) : ''),
            answer16: (getCookie("answer16") ? parseInt(getCookie("answer16")) : ''),
            answer17: (getCookie("answer17") ? parseInt(getCookie("answer17")) : ''),
            answer18: (getCookie("answer18") ? parseInt(getCookie("answer18")) : ''),
            answer19: (getCookie("answer19") ? parseInt(getCookie("answer19")) : ''),
            answer20: (getCookie("answer20") ? parseInt(getCookie("answer20")) : ''),
            answer21: (getCookie("answer21") ? parseInt(getCookie("answer21")) : ''),
            answer22: (getCookie("answer22") ? parseInt(getCookie("answer22")) : ''),
            answer23: (getCookie("answer23") ? parseInt(getCookie("answer23")) : ''),
            answer24: (getCookie("answer24") ? parseInt(getCookie("answer24")) : ''),
            answer25: (getCookie("answer25") ? parseInt(getCookie("answer25")) : ''),
            resultStyle1: '',
            resultStyle2: '',
            resultStyle3: '',
            resultStyle4: '',
            resultStyle5: '',
        };
    },
    props: {
        tile: {},
    },
    computed: {
        
    },
    watch: {
        
    },
    mounted() {
        if (getCookie("answer1")) {
            this.nextIsVisible = 1;
        }
    },
    
    methods: {
        isNextTheme() {
            if (this.currentQuestion % 5 == 0) {
                return 1;
            }

            return 0;
        },


        showAnswer() {
            this.showResult = 1;
        },
        
        showDescription() {
            this.showResult = 0;    
        }, 
           
        showAll() {
            this.isResult = 1;
            this.isSolving = 0;
            this.all = 1;
        },

        reset() {
            this.currentQuestion = 1;
            this.nextIsVisible = 0;
            this.isEnd = 0;
            setCookie("isEnd", 0);
            this.isSolving = 0;
            this.showResult = 0;
            this.all = 0;

            this.answer1 = '';
            this.answer2 = '';
            this.answer3 = '';
            this.answer4 = '';
            this.answer5 = '';
            this.answer6 = '';
            this.answer7 = '';
            this.answer8 = '';
            this.answer9 = '';
            this.answer10 = '';
            this.answer11 = '';
            this.answer12 = '';
            this.answer13 = '';
            this.answer14 = '';
            this.answer15 = '';
            this.answer16 = '';
            this.answer17 = '';
            this.answer18 = '';
            this.answer19 = '';
            this.answer20 = '';
            this.answer21 = '';
            this.answer22 = '';
            this.answer23 = '';
            this.answer24 = '';
            this.answer25 = '';

            for (var i = 1; i < 26; i++) {
                setCookie("answer" + i, '');
            }

            this.resultStyle1 = '';
            this.resultStyle2 = '';
            this.resultStyle3 = '';
            this.resultStyle4 = '';
            this.resultStyle5 = '';
        },
        
        displayResult() {
            this.isResult = 0;
            this.isSolving = 1;
            this.currentQuestion = 26;
            this.nextIsVisible = 0;
            this.showResult = 1;
            
            let theme1p = 0;
            let theme1m = 0;
            let theme2p = 0;
            let theme2m = 0;
            let theme3p = 0;
            let theme3m = 0;
            let theme4p = 0;
            let theme4m = 0;
            let theme5p = 0;
            let theme5m = 0;

            let theme1p_mod = 0;
            let theme1m_mod = 0;
            let theme2p_mod = 0;
            let theme2m_mod = 0;
            let theme3p_mod = 0;
            let theme3m_mod = 0;
            let theme4p_mod = 0;
            let theme4m_mod = 0;
            let theme5p_mod = 0;
            let theme5m_mod = 0;

            if (this.answer1 < 0) { theme1m += this.answer1; } else { theme1p += parseInt(this.answer1); }
            if (this.answer2 < 0) { theme1m += this.answer2; } else { theme1p += parseInt(this.answer2); }
            if (this.answer3 < 0) { theme1m += this.answer3; } else { theme1p += parseInt(this.answer3); }
            if (this.answer4 < 0) { theme1m += this.answer4; } else { theme1p += parseInt(this.answer4); }
            if (this.answer5 < 0) { theme1m += this.answer5; } else { theme1p += parseInt(this.answer5); }

            if (this.answer6 < 0) { theme2m += this.answer6; } else { theme2p += parseInt(this.answer6); }
            if (this.answer7 < 0) { theme2m += this.answer7; } else { theme2p += parseInt(this.answer7); }
            if (this.answer8 < 0) { theme2m += this.answer8; } else { theme2p += parseInt(this.answer8); }
            if (this.answer9 < 0) { theme2m += this.answer9; } else { theme2p += parseInt(this.answer9); }
            if (this.answer10 < 0) { theme2m += this.answer10; } else { theme2p += parseInt(this.answer10); }

            if (this.answer11 < 0) { theme3m += this.answer11; } else { theme3p += parseInt(this.answer11); }
            if (this.answer12 < 0) { theme3m += this.answer12; } else { theme3p += parseInt(this.answer12); }
            if (this.answer13 < 0) { theme3m += this.answer13; } else { theme3p += parseInt(this.answer13); }
            if (this.answer14 < 0) { theme3m += this.answer14; } else { theme3p += parseInt(this.answer14); }
            if (this.answer15 < 0) { theme3m += this.answer15; } else { theme3p += parseInt(this.answer15); }

            if (this.answer16 < 0) { theme4m += this.answer16; } else { theme4p += parseInt(this.answer16); }
            if (this.answer17 < 0) { theme4m += this.answer17; } else { theme4p += parseInt(this.answer17); }
            if (this.answer18 < 0) { theme4m += this.answer18; } else { theme4p += parseInt(this.answer18); }
            if (this.answer19 < 0) { theme4m += this.answer19; } else { theme4p += parseInt(this.answer19); }
            if (this.answer20 < 0) { theme4m += this.answer20; } else { theme4p += parseInt(this.answer20); }

            if (this.answer21 < 0) { theme5m += this.answer21; } else { theme5p += parseInt(this.answer21); }
            if (this.answer22 < 0) { theme5m += this.answer22; } else { theme5p += parseInt(this.answer22); }
            if (this.answer23 < 0) { theme5m += this.answer23; } else { theme5p += parseInt(this.answer23); }
            if (this.answer24 < 0) { theme5m += this.answer24; } else { theme5p += parseInt(this.answer24); }
            if (this.answer25 < 0) { theme5m += this.answer25; } else { theme5p += parseInt(this.answer25); }

            let basex = 35;
            let basey = 31;
            let multi = 23;
    
            let string1 = theme1p + '' + theme1m;
            let string2 = theme2p + '' + theme2m;
            let string3 = theme3p + '' + theme3m;
            let string4 = theme4p + '' + theme4m;
            let string5 = theme5p + '' + theme5m;

            //EDIT TO AVOID OVERLAPING
            if (string1 == string2) { theme1m_mod = 8; theme2m_mod = -8; }
            if (string1 == string3) { theme1m_mod = 8; theme3m_mod = -8; }
            if (string1 == string4) { theme1m_mod = 8; theme4m_mod = -8; }
            if (string1 == string5) { theme1m_mod = 8; theme5m_mod = -8; }
            if (string2 == string3) { theme2m_mod = 8; theme3m_mod = -8; }
            if (string2 == string4) { theme2m_mod = 8; theme4m_mod = -8; }
            if (string2 == string5) { theme2m_mod = 8; theme5m_mod = -8; }
            if (string3 == string4) { theme3m_mod = 8; theme4m_mod = -8; }
            if (string3 == string5) { theme3m_mod = 8; theme5m_mod = -8; }
            if (string4 == string5) { theme4m_mod = 8; theme5m_mod = -8; }

            this.resultStyle1 = {"left" : ((theme1p * multi) + basex) + "px", "top" :  (((-1 * theme1m) * multi) + basey + theme1m_mod) + "px"};
            this.resultStyle2 = {"left" : ((theme2p * multi) + basex) + "px", "top" :  (((-1 * theme2m) * multi) + basey + theme2m_mod) + "px"};
            this.resultStyle3 = {"left" : ((theme3p * multi) + basex) + "px", "top" :  (((-1 * theme3m) * multi) + basey + theme3m_mod) + "px"};
            this.resultStyle4 = {"left" : ((theme4p * multi) + basex) + "px", "top" :  (((-1 * theme4m) * multi) + basey + theme4m_mod) + "px"};
            this.resultStyle5 = {"left" : ((theme5p * multi) + basex) + "px", "top" :  (((-1 * theme5m) * multi) + basey + theme5m_mod) + "px"};
        },

        nextQuestion() {
            if (this.currentQuestion < 25) {
                this.currentQuestion++;
                if (getCookie("answer" + this.currentQuestion)) {
                    this.nextIsVisible = 1;
                } else {
                    this.nextIsVisible = 0;
                }
            } else {
                this.isEnd = 1;
                setCookie("isEnd", 1)
            }
        },

        setAnswer(q, a) {
            switch (q) {
                case 1: this.answer1 = a; setCookie("answer1", a); break;
                case 2: this.answer2 = a; setCookie("answer2", a); break;
                case 3: this.answer3 = a; setCookie("answer3", a); break;
                case 4: this.answer4 = a; setCookie("answer4", a); break;
                case 5: this.answer5 = a; setCookie("answer5", a); break;
                case 6: this.answer6 = a; setCookie("answer6", a); break;
                case 7: this.answer7 = a; setCookie("answer7", a); break;
                case 8: this.answer8 = a; setCookie("answer8", a); break;
                case 9: this.answer9 = a; setCookie("answer9", a); break;
                case 10: this.answer10 = a; setCookie("answer10", a); break;
                case 11: this.answer11 = a; setCookie("answer11", a); break;
                case 12: this.answer12 = a; setCookie("answer12", a); break;
                case 13: this.answer13 = a; setCookie("answer13", a); break;
                case 14: this.answer14 = a; setCookie("answer14", a); break;
                case 15: this.answer15 = a; setCookie("answer15", a); break;
                case 16: this.answer16 = a; setCookie("answer16", a); break;
                case 17: this.answer17 = a; setCookie("answer17", a); break;
                case 18: this.answer18 = a; setCookie("answer18", a); break;
                case 19: this.answer19 = a; setCookie("answer19", a); break;
                case 20: this.answer20 = a; setCookie("answer20", a); break;
                case 21: this.answer21 = a; setCookie("answer21", a); break;
                case 22: this.answer22 = a; setCookie("answer22", a); break;
                case 23: this.answer23 = a; setCookie("answer23", a); break;
                case 24: this.answer24 = a; setCookie("answer24", a); break;
                case 25: this.answer25 = a; setCookie("answer25", a); break;
            }
            
            this.nextIsVisible = 1;
        }
    }
}

</script>

<style scoped>
   
        
</style>
